import 'scss/solutions/miniAppSolution.scss'
import 'babel-polyfill'
import 'js/libs/common'
import 'js/libs/utils-solutions'
import { checkUserCertificate, showLoginModal } from 'js/libs/utils-login'
import { config } from 'config'
import * as userApi from 'js/api/user'

$(function () {
  $('.join-now').click(function () {
    var $this = $(this)
    var href = $this.data('href')
    userApi.checkLogin().then(result => {
      if (result.code === 80000) {
        showLoginModal()
      } else {
        window.open(href)
      }
    })
  })
  $('#view_video').bind('click', function () {
    $.alerts.alert('即将上线，敬请期待')
  })
  $('#upgrade_limit').click(function () {
    checkUserCertificate(function (certificate, msg) {
      if (!certificate) {
        $.alerts.confirm(msg + '，请先进行实名认证', '前往认证', '以后再说', function (go) {
          if (go) {
            location.href = config.CONSOLE + 'user/personaldata'
          }
        })
      } else {
        location.href = config.CONSOLE + 'app/myapp'
      }
    })
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/solutions/miniAppSolution.js